export default __webpack_public_path__ + "static/media/vippeloftmedfarge2_Page_2.4464f31f.png";